<template>
  <v-numeric-text-field
    :label="label"
    v-model="numberFormated"
    :rules="rulesData"
    @blur="parseNumber()"
    v-bind="mergedTextFieldProps"
    :suffix="suffix"
  />
</template>

<script>
import rulesMixin from '@/components/generic/rules.js'
import _ from 'lodash'
export default {
  name: 'o-numeric-text-field',
  mixins: [rulesMixin],
  props: {
    value: {},
    label: {
      type: String,
      default: null
    },
    textFieldProps: {},
    disabled: {
      default: false
    },
    readonly: {
      default: false
    },
    rulesProps: {
      type: Array,
      default: null
    },
    precision: {
      type: Boolean,
      default: false
    },
    suffix: {
      type: String,
      default: ''
    }
  },
  created () {
    this.updateFormatted(this.value)
  },
  data () {
    return {
      numberFormated: null,
      returnedValue: null
    }
  },
  computed: {
    emitV: {
      get () {
        return this.numberFormated
      },
      set (val) {
        this.$emit('input', this.$options.filters.removeDecimalInput(val))
      }
    },
    mergedTextFieldProps () {
      let def = {
        disabled: this.disabled,
        readonly: this.readonly
      }
      return _.merge(def, this.textFieldProps)
    },
    rulesData: {
      get () {
        if (this.rulesProps) {
          return [this.rules.precioNumber].concat(this.rulesProps.slice(0))
        } else {
          return [this.rules.precioNumber]
        }
      }
    }
  },
  methods: {
    updateFormatted (newVal) {
      if (this.precision) {
        this.numberFormated = this.$options.filters.decimalInputPrecision(newVal)
      } else {
        this.numberFormated = this.$options.filters.decimalInput(newVal)
      }
    },
    parseNumber () {
      if (this.numberFormated === '') {
        this.numberFormated = null
      }
      this.$emit('input', this.$options.filters.removeDecimalInput(this.numberFormated))
    }
  },
  watch: {
    value (newVal) {
      this.updateFormatted(newVal)
    }
  }
}
</script>